module.exports = __webpack_public_path__ + "static/img/logo.684510d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.svg
// module id = 47hR
// module chunks = 1